var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52925 5.52729C3.7896 5.26694 4.21171 5.26694 4.47206 5.52729L8.00065 9.05589L11.5292 5.52729C11.7896 5.26694 12.2117 5.26694 12.4721 5.52729C12.7324 5.78764 12.7324 6.20975 12.4721 6.4701L8.47206 10.4701C8.21171 10.7305 7.7896 10.7305 7.52925 10.4701L3.52925 6.4701C3.2689 6.20975 3.2689 5.78764 3.52925 5.52729Z",
    fill: "#9091A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDown);
export default __webpack_public_path__ + "static/media/ic-chevron-down.d2bfe7687eaf525ce19570c6122c57c2.svg";
export { ForwardRef as ReactComponent };